import { Suspense, useEffect, useMemo, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { Col } from '@guestyci/foundation/Layout';
import PageLoadingSpinner from '../../shareable/PageLoadingSpinner';
import getRemoteApp, { getRemoteAppProps } from './remote-apps';

function Loading({ onUnmount }: { onUnmount: (arg: boolean) => void }) {
  useEffect(() => {
    console.log('Loading ModuleApp', Date.now());
    return () => {
      console.log('ModuleApp is loaded', Date.now());
      onUnmount(false);
    };
  }, []);
  return <PageLoadingSpinner />;
}

function ModuleFederationApp({ repositoryName }: { repositoryName: string }) {
  const { path: baseUrl } = useRouteMatch();
  const [, setLoading] = useState(true);

  const RemoteApp = useMemo(
    () => getRemoteApp(repositoryName),
    [repositoryName]
  );

  const remoteAppProps = useMemo(
    () => getRemoteAppProps(repositoryName, baseUrl),
    [repositoryName, baseUrl]
  );

  return (
    // @ts-ignore
    <Col id={repositoryName} fullWidth className="h-100">
      <Suspense fallback={<Loading onUnmount={setLoading} />}>
        {/* @ts-ignore */}
        <RemoteApp {...remoteAppProps} />
      </Suspense>
    </Col>
  );
}

export default ModuleFederationApp;
